import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { locales } from '../../../config'; 
class CurrencyView extends Component {
    static propTypes = {
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired
    };

    render() {
        const { amount, currency } = this.props;
        return (
            <span>
                {amount.toLocaleString(locales[0], { style: 'currency', currency })}
            </span>
        );
    }
}

export default CurrencyView;
